import React, { Children, ReactNode, useEffect, useRef, useState } from 'react'
import { ContainerPropsTypes } from './ContainerTypes'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'

const Container = (props: ContainerPropsTypes) => {

    const [children, setChildren] = useState<ReactNode[]>([])

    useEffect(() => {
        if(props.tabs && props.selectedTab){
            setChildren(prevState => Children.toArray(props.children))
        }
    }, [])

    return (
        <div className={`container-wrapper`}>
            {props.title && (
                <span className={`title`}>{props.title}</span>
            )}

            {props.tabs ? (
                <>
                    <div className='tab-area'>
                        {props.tabs.map((tab, index) => (
                            <span key={index} style={{backgroundColor: props.selectedTab === tab ? 'color-mix(in oklab, var(--color-accent), black var(--value-background-mix))' : 'color-mix(in oklab, var(--color-main-black), white var(--value-tab-not-selected-mix))'}}>{tab.replace(/_/g, ' ')}</span>
                        ))}
                    </div>
                    
                    {props.tabs.map((tab, index) => (
                        <div key={index} style={{display: props.selectedTab === tab ? 'block' : 'none', width: '100%', height: '100%'}}>
                            {children[index]}
                        </div>
                        /* props.selectedTab === tab && (
                            children[index]
                        ) */
                    ))}
                </>
                
            ) : (
                props.children
            )}

            {/* Loading screen */}
            {props.isLoading && (
                <LoadingScreen />
            )}
        </div>
    )
}

export default Container